import { useEffect } from 'react';

import {
  FloraButton,
  Tag,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
} from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';
import { ONBOARDINGS } from 'config/environments/shared';
import { FloraProvider } from 'containers/ProviderComposer/providers/FloraProvider';
import { getOnboarding } from 'helpers';
import { useTracking } from 'hooks';

import Styles from './ModalOnboarding.styles';

export const ModalOnboarding = () => {
  const { onboardingViewed } = getOnboarding(ONBOARDINGS.IMAGES_TO_SHARE);
  const { sendDataToGTM } = useTracking();
  const endOnboarding = () => {
    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'interaction_novidades_ciclo',
        cd_interaction_detail: 'click:concluir',
        cd_section: 'imagens-de-divulgacao',
      },
    });
    return onboardingViewed();
  };
  useEffect(() => {
    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'view_modal_onboarding',
        cd_section: 'imagens-de-divulgacao',
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal defaultOpen>
      <ModalContent>
        <FloraProvider>
          <Styles.ModalHeader>
            <Tag variant='success'>NOVO</Tag>
          </Styles.ModalHeader>
          <ModalBody>
            <Flex gap='$4' direction='column'>
              <ResponsiveFloraTypography color='$backgroundAltPrimary' fontSize='title' as='h5'>
                Imagens de divulgação
              </ResponsiveFloraTypography>

              <ResponsiveFloraTypography css={{ lineHeight: '24px' }}>
                Compartilhe materiais sobre novidades e promoções e aumente as suas vendas.
              </ResponsiveFloraTypography>
              <ResponsiveFloraTypography>
                Após clicar em baixar, se necessário, permita pop-ups no seu navegador.
              </ResponsiveFloraTypography>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <ModalCloseButton asChild>
              <FloraButton onClick={endOnboarding}>Concluir</FloraButton>
            </ModalCloseButton>
          </ModalFooter>
        </FloraProvider>
      </ModalContent>
    </Modal>
  );
};
